import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import { getCatalogPageByPath } from "@insite/client-framework/Services/CategoryService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSelectedCategoryPath } from "@insite/client-framework/Store/Context/ContextSelectors";
import CatalogPagesReducer from "@insite/client-framework/Store/Data/CatalogPages/CatalogPagesReducer";
import { getCatalogPageStateByPath } from "@insite/client-framework/Store/Data/CatalogPages/CatalogPagesSelectors";
import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { CatalogPageModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    showImages = "showImages",
}

const mapStateToProps = (state: ApplicationState, ownProps: { categoryId: string }) => {
    const location = getLocation(state);
    const categoryPath =
        getSelectedCategoryPath(state) ||
        (location.pathname.toLowerCase().startsWith("/content/") ? "" : location.pathname);
    const catalogPageState = getCatalogPageStateByPath(state, categoryPath);
    return {
        catalogPageState,
        category: getCategoryState(state, ownProps.categoryId).value,
    };
};
interface Props extends WidgetProps, HasCategoryContext {}

export interface CategoryDetailSubCategoriesStyles {
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    container?: GridContainerProps;
    categoryHeading?: InjectableCss;
    titleText?: InjectableCss;
    allCategoryLink?: InjectableCss;
    categoryItem?: GridItemProps;
    innerContainer?: GridContainerProps;
    categoryImageItem?: GridItemProps;
    categoryImageLink?: LinkPresentationProps;
    categoryImage?: LazyImageProps;
    categoryNameLinkItem?: GridItemProps;
    categoryNameLink?: LinkPresentationProps;
    categoryName?: TypographyProps;
    subCategoryNameLinkItem?: GridItemProps;
    subCategoryNameLink?: LinkPresentationProps;
    viewMoreLinkItem?: GridItemProps;
    viewMoreLink?: LinkPresentationProps;
}

export const categoryDetailSubCategoriesStyles: CategoryDetailSubCategoriesStyles = {
    centeringWrapper: {
        css: css`
            height: 300px;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    container: {
        gap: 30,
        css: css`
            max-width: 1300px;
            margin: 0 auto;
            > div[class^="GridOffset"] {
                // width: 100%;
                // margin: 0px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-width: 100%;
                    `,
                    css`
                        max-width: 100%;
                    `,
                    css`
                        max-width: 100%;
                    `,
                    css`
                        max-width: 100%;
                    `,
                    css`
                        max-width: 1300px;
                        margin: 0 auto;
                    `,
                ])}
        `,
    },
    categoryHeading: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            max-width: 1300px;
            margin: 0 auto;
            padding: 0;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-width: 100%;
                    `,
                    css`
                        max-width: 100%;
                    `,
                    css`
                        max-width: 100%;
                    `,
                    css`
                        max-width: 100%;
                    `,
                    css`
                        max-width: 1300px;
                        margin: 0 auto;
                    `,
                ])}
        `,
    },
    titleText: {
        css: css`
            letter-spacing: 0px;
            font-size: 22px;
            font-weight: normal;
            line-height: 1;
            margin-bottom: 36px;
            padding-top: 36px;
        `,
    },
    categoryNameLink: {
        css: css`
            height: 100%;
            width: 100%;
            span {
                margin: 0 auto;
            }
        `,
    },
    allCategoryLink: {
        css: css`
            letter-spacing: 0px;
            font-family: inherit;
            min-height: 40px;
            font-size: 16px;
            font-weight: normal;
            line-height: 1;
            padding: 0 21px;
            border-radius: 20px;
            border: 2px solid;
            border-color: ${getColor("primary")};
            text-align: center;
            span {
                color: ${getColor("primary")} !important;
            }
            transition: all 200ms ease-in-out;
            &:hover {
                background-color: ${getColor("primary")};
                span {
                    color: #fff !important;
                }
            }
        `,
    },
    categoryItem: {
        // width is dynamic here
        css: css`
            max-width: 20%;
            flex-basis: 20%;
            div[class^="GridWrapper"] {
                height: 100%;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-width: 50%;
                        flex-basis: 50%;
                    `,
                    css`
                        max-width: 50%;
                        flex-basis: 50%;
                    `,
                    css`
                        max-width: 33.33%;
                        flex-basis: 33.33%;
                    `,
                    css`
                        max-width: 25%;
                        flex-basis: 25%;
                    `,
                    css``,
                ])}
        `,
    },
    innerContainer: {
        gap: 10,
        css: css`
            > div[class^="GridOffset"] {
                margin: auto;
                height: 100%;
            }
            transition: box-shadow 0.2s ease-in-out 0s;
            &:hover {
                box-shadow: rgb(33 33 33 / 50%) 0px 6px 10px 0px;
            }
        `,
    },
    categoryImageItem: {
        width: 12,
        css: css`
            height: 100%;
            padding: 0px;
            border: 1px solid rgb(204, 204, 204);
            box-shadow: rgb(255 255 255) 5px 10px 18px;
            &:hover {
                border: 1px solid ${getColor("primary")};
            }
        `,
    },
    categoryImage: {
        // height: "160px",
        css: css`
            width: 100%;
            display: block;

            img {
                height: auto;
                width: 100%;
                aspect-ratio: 1/1;
                object-fit: cover;
            }
        `,
    },
    categoryImageLink: {
        css: css`
            width: 100%;
            display: block;
            span {
                width: 100%;
            }
        `,
    },
    categoryNameLinkItem: {
        width: 12,
        css: css`
            background-color: ${getColor("primary")};
            justify-content: center;
            height: 100%;
            text-align: center;
        `,
    },
    categoryName: {
        css: css`
            color: #fff;
            font-weight: bold;
        `,
    },
    subCategoryNameLinkItem: {
        width: 12,
    },
    viewMoreLinkItem: {
        width: 12,
        css: css`
            font-weight: bold;
            padding-top: 10px;
        `,
    },
};

const styles = categoryDetailSubCategoriesStyles;

const CategoryDetailSubCategories = ({ category, fields: { showImages } }: Props) => {
    if (!category || !category.subCategoryIds || category.subCategoryIds.length === 0) {
        return null;
    }

    return (
        <GridContainer {...styles.container}>
            {category.subCategoryIds.map(subCategoryId => (
                <SubCategoryLink categoryId={subCategoryId} showImages={showImages} key={subCategoryId}/>
            ))}
        </GridContainer>
    );
};

const SubCategoryLinkView = ({
    category,
    showImages,
    catalogPageState,
}: ReturnType<typeof mapStateToProps> & { showImages: boolean }) => {
    if (!category || category?.properties["hideFromNav"] === "true" ) {
        return null;
    }

    const brandId = catalogPageState.value?.brandId;
    return (
        <GridItem key={category.id} {...styles.categoryItem}>
                <GridContainer {...styles.innerContainer}>
            {showImages &&  (
                <GridItem {...styles.categoryImageItem}>
                    <StyledWrapper
                        css={css`
                            display: inline-flex;
                            flex-direction: column;
                            height: 100%;
                            width: 100%;
                        `}
                    >
                        {category.path  &&
                            (brandId !== null ? (
                                <Link href={`${category.path}`} {...styles.categoryImageLink}>
                                    <LazyImage
                                        src={
                                            category.smallImagePath ? category.smallImagePath : category.largeImagePath
                                        }
                                        {...styles.categoryImage}
                                    />
                                </Link>
                            ) : (
                                <Link href={`${category.path}`} {...styles.categoryImageLink}>
                                    <LazyImage
                                        src={
                                            category.largeImagePath ? category.largeImagePath : category.smallImagePath
                                        }
                                        {...styles.categoryImage}
                                    />
                                </Link>
                            ))}
                        <StyledWrapper {...styles.categoryNameLinkItem}>
                            <Link href={`${category.path}`} {...styles.categoryNameLink}>
                                <Typography {...styles.categoryName}>{category.shortDescription}</Typography>
                            </Link>
                        </StyledWrapper>
                    </StyledWrapper>
                </GridItem>
            )}
        </GridContainer>
        </GridItem>
    );
};

const SubCategoryLink = connect(mapStateToProps)(SubCategoryLinkView);

const widgetModule: WidgetModule = {
    component: withCategory(CategoryDetailSubCategories),
    definition: {
        group: "Category Details",
        icon: "list-ul",
        fieldDefinitions: [
            {
                name: fields.showImages,
                displayName: "Show Images",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 1,
            },
        ],
        allowedContexts: ["CategoryDetailsPage"],
    },
};

export default widgetModule;
